import * as DefaultCTA from './default-cta'
import * as DocsPageCTA from './docs-page-cta'

export const CTA_MAP = {
  default: DefaultCTA,
  docsPage: DocsPageCTA,
} as const

export type CTAKey = keyof typeof CTA_MAP

export function getCTAByKey(key: CTAKey) {
  return CTA_MAP[key]
}
